import React from 'react'

const Loader = () => (
    <div id="content" className="ibk-loading pt-0">
        <div className="ibk-loading-box">
            <img
                src="/assets/images/common/icon-loading-ani.svg"
                alt="로딩중"
                width={92}
                height={90}
            />
            <h2 className="h4 mt-32">정보를 불러오고 있어요</h2>
            <p className="mt-04">잠시만 기다려주세요.</p>
        </div>
    </div>
)
export default Loader
